import React from "react";
import {
  LobbyInitData,
  Vehicle,
  LobbyRefreshData,
} from "../../../../types/lobby";
import VehicleStatusBox from "./vehicleStatusBox/VehicleStatusBox";
import NoselectVehicleBox from "./NoVehicleBox/NoVehicleBox";
import "./VehicleStatusList.scss";

interface Props {
  initData: LobbyInitData | null;
  refreshDataMap: Record<string, LobbyRefreshData>;
  isMqttConnected: boolean;
}

const VehicleStatusList: React.FC<Props> = ({
  initData,
  refreshDataMap,
  isMqttConnected,
}) => {
  const vehicles = initData?.vehicles || [];

  const paddedVehicles: (Vehicle | null)[] = [...vehicles];
  while (paddedVehicles.length < 4) {
    paddedVehicles.push(null);
  }

  return (
    <div className="vehicleStatusList">
      {paddedVehicles.map((vehicle, i) =>
        vehicle ? (
          <VehicleStatusBox
            key={vehicle.vehicle_communication_code}
            vehicleCommunicationCode={vehicle.vehicle_communication_code}
            vehicleNo={vehicle.vehicle_no}
            vehicleLabel={vehicle.vehicle_label}
            refreshData={refreshDataMap[vehicle.vehicle_communication_code]}
            isMqttConnected={isMqttConnected}
          />
        ) : (
          <NoselectVehicleBox key={`noselect-${i}`} />
        )
      )}
    </div>
  );
};

export default VehicleStatusList;
